import type { PublicProjectRecord } from '@/content/schemas';

function comparePublishedProjects(
  left: PublicProjectRecord,
  right: PublicProjectRecord
) {
  const featuredDelta = Number(right.featured) - Number(left.featured);
  if (featuredDelta !== 0) return featuredDelta;

  const orderDelta =
    (left.featuredOrder ?? Number.MAX_SAFE_INTEGER) -
    (right.featuredOrder ?? Number.MAX_SAFE_INTEGER);
  if (orderDelta !== 0) return orderDelta;

  const dateDelta = right.publishedAt.localeCompare(left.publishedAt);
  if (dateDelta !== 0) return dateDelta;

  return left.slug.localeCompare(right.slug);
}

export function sortPublishedProjects(
  projects: PublicProjectRecord[]
): PublicProjectRecord[] {
  return [...projects].sort(comparePublishedProjects);
}

export function selectFeaturedCaseStudies(
  projects: PublicProjectRecord[]
): PublicProjectRecord[] {
  return sortPublishedProjects(projects).filter(
    (project) =>
      project.featured &&
      project.detailStatus === 'case-study' &&
      Boolean(project.route)
  );
}

export function selectPublishedProjects(
  projects: PublicProjectRecord[]
): PublicProjectRecord[] {
  return sortPublishedProjects(projects);
}

export function selectCaseStudyBySlug(
  projects: PublicProjectRecord[],
  slug: string
): PublicProjectRecord | undefined {
  return projects.find(
    (project) =>
      project.slug === slug &&
      project.detailStatus === 'case-study' &&
      Boolean(project.route)
  );
}

export function isCaseStudyProject(project: PublicProjectRecord): boolean {
  return project.detailStatus === 'case-study' && Boolean(project.route);
}
